import { Injectable } from "@angular/core";

import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import * as blogActions from "../../section-blog/ng-store/action/blog.action";
import * as fromRoot from "../../section-blog/ng-store/index";
import {filter, map, take} from "rxjs/operators";
import {BlogState} from "../../section-blog/ng-store/reducer/blog.reducer";
import {ArticleModel} from "../ng-store/model/article.model";

@Injectable({ providedIn: 'root' })
export class BlogListResolver  {
  constructor(private store: Store) {}

  resolve(): Observable<ArticleModel[]> {
    // Dispatch the action to load the article
    this.store.dispatch(blogActions.blog());

    // Wait for the article to be loaded successfully or fail
    return this.store.select(fromRoot.blogSelector).pipe(
      filter((state: BlogState) => state.isDownloadingSuccess || state.isDownloadingFailure),
      take(1),
      map((state: BlogState) => state.blog.Items)
    );
  }
}
